<template>
  <div class="quest-type">
    <div class="icon-container d-flex align-items-center justify-content-center"
         :class="questTypeClassBackground(questType)">
      <SymbolIcon :iconName="questType" :color="'white'" :hoverName="PrettyName[questType]"></SymbolIcon>

    </div>
    <div class="title">
      <span>
        {{ questTypeToString(questType) }}
      </span>
    </div>
    <div class="score d-flex align-items-center justify-content-center">
      {{ amount }}
    </div>
  </div>
</template>

<script>
import QuestTypeHelper from "@/mixins/QuestTypeHelper";
import SymbolIcon from "@/components/UI/SymbolIcon.vue";
import {PrettyName} from "@/enums/PrettyName";

export default {
  name: "QuestTypeLabel",
  computed: {
    PrettyName() {
      return PrettyName
    }
  },
  components: {SymbolIcon},
  props: {
    questType: String,
    amount: Number
  },
  mixins: [ QuestTypeHelper ]
}
</script>

<style lang="scss" scoped>
.quest-type
{
  background-color: white;
  border-radius: 5px;
  box-shadow: $default-shadow;
  margin-bottom: 0.66rem;

  display: flex;

  height: 50px;

  .icon-container
  {
    min-width: 50px;
    overflow: visible;

    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;

    svg
    {
      fill: $font-light;
    }
  }

  .title
  {
    padding: 10px;
    flex: 1 1;

    display: flex;
    flex-direction: row;

    justify-content: flex-start;
    align-items: center;

    font-size: 0.875rem;
    font-weight: 500;

    min-width: 0; // To make the ellipsis work https://css-tricks.com/flexbox-truncated-text/

    span
    {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-right: 5px;
    }
  }

  .score
  {
    aspect-ratio: 1 / 1;
    margin-right: 10px;
  }
}
</style>